/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export enum WizardTitleEnum {
    TEMPLATE = 'Template Selection',
    // Layer 4 and Layer 7
    FRONTENDS = 'Frontends',
    BACKENDS = 'Backends',
    REALSERVERS = 'Real Servers',
    ACLS = 'Acls',
    MONITORS = 'Monitors',
    HEADERS = 'Headers',
    // GSLB
    GLOBALNAMES = 'Global names',
    MEMBERS = 'Members',
    POOLS = 'Pools',
    TOPOLOGIES = 'Topologies',
    // Wizard sections
    SUCCESS = 'Success',
    REFERENCE = 'Reference',
    PROPERTIES = 'Properties',
    HIDDENSECTIONS = 'hiddenSections',
}
